import * as fs from 'node:fs';

export async function readWorktreeFileLines(filePath: string): Promise<string[] | null> {
  try {
    const raw = await fs.promises.readFile(filePath, 'utf8');
    return raw.split(/\r?\n/);
  } catch {
    return null;
  }
}
